export const LOCAL_STORAGE_KEY = 'growth-data';

export const TAGLINES = [
  {
    quote: 'Because paper charts are hard.',
    author: 'Millenial',
    source: 'Tales of the Digital Age',
  },
  {
    quote: "Who's got the time and energy to find the damn paper?",
    author: 'A new parent',
    source: 'Children of Fury',
  },
  {
    quote: 'My toddler destroyed the original!',
    author: 'Anonymous parent',
    source: 'Chronicles of the Twisted Paper',
  },
];

// see chart.scss
export const COLOURS = [
  '#0544d3',
  '#d17905',
  '#59922b',
  '#d70206',
  '#6b0392',
  '#f4c63d',
  '#453d3f',
  '#e6805e',
  '#dda458',
  '#eacf7d',
  '#86797d',
  '#b2c326',
  '#6188e2',
  '#a748ca',
];
